<template>
    <div class="myworkinfo">
        <div class="mynav">
            <dl>
                <dd v-for="item in conavlist" :key="item.id" v-if="!$store.getters.issmall || item.kv<3 || item.kv==99">
                    <a href="#" :class="{cs:curnavkv==item.kv}" @click="showinfolist(item.kv)">{{item.title}}</a>
                </dd>
            </dl>
        </div>
        <div class="infosearch">
            <el-input class="searchinput" placeholder="请输入搜索内容" v-model="kw" @change="searchdata()" clearable>
                <el-button slot="append" icon="el-icon-search" size="mini"></el-button>
            </el-input>
            <div class="searchbtn">
                <a href="#" @click="gopage('infoedit')"><i class="iconfont icon-fabu"></i>我要投诉</a>
            </div>
        </div>
        <div class="myinfolist">
            <div class="myinfowrap" v-for="item in conavlist" :key="item.id" v-show="item.kv==curnavkv">
                <myScroll class="scroll" @handle-scroll="handleScroll">
                    <div class="myinfobox" v-if="item.kv==1 && conabout">
                        <div class="myabout" v-html="conabout"></div>

                    </div>

                    <div class="myinfobox">
                        <template v-if="getcurinfo(item.kv).isload">
                            <div class="myinfo" v-if="getcurinfo(item.kv).res.recordcount">
                                <div class="myinfoitem" v-for="item2 in getcurinfo(item.kv).mylist" :key="item2.id">
                                    <div class="mynews divlink" v-if="item.kv==1" @click="gopage('infodetail',item2.id)">
                                        <div v-if="false" class="mynewscover"><ffimg :imgsrc="item2.cover" :isstatic="true" /></div>
                                        <dl class="mynewsinfo">
                                            <dd class="a"><span class="a1wrap" v-if="item2.title"><span class="a1"><span>{{item2.infocatalog}}</span></span></span>{{item2.title}}</dd>
                                            <dd class="b">
                                                <dl>
                                                    <dt> <span class="b1" v-if="item2.showname">{{item2.showname}}</span>{{$common.basic.dateformat(item2.publishdate,'yyyy-MM-dd hh:mm:ss')}}</dt>
                                                    <dd><ffcounts :options="item2.x_counts"></ffcounts></dd>
                                                </dl>
                                            </dd>
                                        </dl>
                                    </div>

                                    <div class="myco divlink" v-else @click="gopage('infodetail',item2.id)">

                                        <div class="mycomember">
                                            <div class="mycomemberavatar">
                                                <img :src="item2.x_avatar" />
                                            </div>
                                            <dl class="mycomemberinfo">
                                                <dt>{{item2.x_showname}}</dt>
                                                <dd>{{$common.basic.dateformat(item2.publishdate)}}</dd>
                                            </dl>
                                            <div class="mycostat">
                                                <div class="mystat stat0" v-if="item2.iscancel"><span></span>已撤回</div>
                                                <div class="mystat curstat" :style="{backgroundColor:getcurstat(item2.stat).colorhex}" v-else><span></span>{{getcurstat(item2.stat).title}}</div>
                                            </div>
                                        </div>

                                        <dl class="mycoinfo">
                                            <dt>{{item2.eventother||item2.eventtitle}}</dt>
                                            <dd class="a editor" v-html="item2.content"></dd>
                                            <dd class="c" v-if="item2.imgs" v-viewer>
                                                <dl>
                                                    <dd v-for="(item3,index3) in item2.x_imgs" :key="index3">
                                                        <ffimg :imgsrc="item3" :isstatic="true"></ffimg>
                                                    </dd>
                                                </dl>

                                            </dd>
                                            <dd class="b"><span>[我的身份]</span>{{item2.mytypetitle}}</dd>
                                            <dd class="b"><span>[投诉对象]</span>{{item2.targettypetitle}}</dd>
                                            <dd class="b"><span>[投诉要求]</span>{{item2.reqtitle}}</dd>
                                            <dd class="b" v-if="item.kv==99"><span>[是否公开]</span>{{item2.isprivate?'否':'是'}}</dd>
                                        </dl>

                                        <div class="mycocount">
                                            <ffcounts :options="item2.x_counts"></ffcounts>
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <div v-else class="norecord">暂无记录</div>
                        </template>
                        <div class="myinfoload" v-if="getcurinfo(item.kv).isloading">
                            <i class="el-icon-loading"></i>正在加载
                        </div>
                    </div>
                </myScroll>
            </div>

        </div>
    </div>
</template>

<script>
    import { mixinpage } from "@/mixin/mixin"

    export default {
        name: 'Chome',
        mixins: [mixinpage],
        data() {
            return {
                conavlist: [],
                curnavkv: 0,
                statlist: [],
                kw: '',
                infolist: [],
                conabout: ''
            };
        },
        computed: {
            curinfo: function () {
                return this.$common.basic.fffind(this.infolist, 'kv', this.curnavkv);
            }
        },
        methods: {
            showinfolist: function (v) {
                let kv = v;
                if (v == 100) {

                    kv = 99;
                    let item = this.getcurinfo(99);
                    item.isload = false;
                    item.res = {};
                    item.isloading = false;
                    item.mylist = [];
                }
                if (v == 100 || this.curnavkv != kv) {
                    if (kv == 99 && !this.$store.state.islogin) {
                        this.gopage('login');
                    }
                    else {
                        this.curnavkv = kv;
                        if (!this.curinfo.isload) {
                            this.getdata();
                        }
                    }

                }
            },
            initdata: function () {
                this.$common.fetch({ 'act': 'sht_home_init', 'msg': '' }, res => {
                    this.conavlist = res.infodata;

                    if (!this.curnavkv) {
                        this.curnavkv = res.infodata[0].kv;
                    }
                    this.$common.each(res.infodata, item => {
                        this.infolist.push({ mylist: [], res: {}, kv: item.kv, isload: false, isloading: false });
                    });
                    this.statlist = res.infodatastat;
                    if (this.$common.basic.isobjexist(res.infodataabout)) {

                        let infodataabout = this.$common.basic.ffjsonparse(res.infodataabout.jsonpar);

                        this.conabout = infodataabout.content;
                    }


                    this.getdata();
                });
            },
            getdata: function () {

                if (this.curinfo.isloading) {
                    return false;
                }
                if (this.$common.basic.isobjexist(this.curinfo.res)) {
                    if (this.curinfo.res.cpage > this.curinfo.res.pagemax) {
                        return false;
                    }
                }
                this.curinfo.isloading = true;
                let jsondata = {
                    'postdata': { 'act': 'sht_home_infolist', 'data': { 'kv': this.curnavkv, 'kw': this.kw }, 'cpage': this.curinfo.res.cpage }, 'msg': ''
                };
                this.$common.post(jsondata, res => {
                    this.curinfo.res = res;
                    this.$common.each(res.infodata, item => {
                        let itemcomment = this.$common.basic.fffind(res.infodatacomments, 'targetid', item.id);
                        item.comments = this.$common.basic.isobjexist(itemcomment) ? itemcomment.comments : 0;

                        let itemmyzan = this.$common.basic.fffind(res.infodatamyzan, 'targetid', item.id);
                        item.iszanme = this.$common.basic.isobjexist(itemmyzan);
                        let itemmycomment = this.$common.basic.fffind(res.infodatamycomment, 'targetid', item.id);
                        item.iscommentme = this.$common.basic.isobjexist(itemmycomment);

                        item.x_counts = {
                            viewcount: item.viewcount,
                            comments: item.comments,
                            zancount: item.zancount,
                            iscommentme: item.iscommentme,
                            iszanme: item.iszanme,
                            iszancan: false,
                            targetid: item.id
                        }
                        item.x_tartype = '';
                        let itemtartype = this.$common.basic.fffind(res.infodatatartype, 'id', item.tartype);
                        if (this.$common.basic.isobjexist(itemtartype)) {
                            item.x_tartype = itemtartype.title;
                        }
                        item.x_avatar = '';
                        item.x_showname = '';
                        //if (this.curnavkv == 99) {
                        //    item.x_avatar = this.$common.getavatar(item.isanon ? '' : this.$store.state.avatar);
                        //    item.x_showname = item.isanon ? this.parglobal.txtanon : this.$store.state.showname;
                        //}
                        //else
                        if (this.curnavkv > 1) {
                            let itemmember = this.$common.basic.fffind(res.infodatamember, 'id', item.mid);

                            if (this.$common.basic.isobjexist(itemmember)) {
                                item.x_avatar = itemmember.avatar;
                                item.x_showname = itemmember.showname;
                            }
                            item.x_avatar = item.isanon ? '' : item.x_avatar;
                            item.x_avatar = this.$common.getavatar(item.x_avatar);
                            item.x_showname = item.isanon ? this.parglobal.txtanon : item.x_showname || this.parglobal.txtanon;
                        }

                        item.x_imgs = [];
                        if (item.imgs) {
                            item.x_imgs = item.imgs.split(',');
                        }
                    });

                    this.curinfo.isload ? this.curinfo.mylist.push(...res.infodata) : this.curinfo.mylist = res.infodata;
                    this.curinfo.isload = true;
                    this.curinfo.isloading = false;

                });
            },
            getcurinfo: function (v) {
                return this.$common.basic.fffind(this.infolist, 'kv', v);
            },
            getcurstat: function (v) {
                return this.$common.basic.fffind(this.statlist, 'kv', v);
            },
            searchdata: function () {
                this.$common.each(this.infolist, item => {
                    item.isload = false;
                    item.res = {};
                    item.isloading = false;
                    item.mylist = [];
                    if (this.curnavkv == item.kv) {
                        this.getdata();
                    }

                });
            },
            handleScroll: function (v) {
                if ((v.process == 1) && !this.curinfo.isloading) {
                    this.curinfo.res.cpage++;
                    this.getdata();
                }
            }
        },
        mounted() {
            this.initdata();

        },
        watch: {
            'parpage.id'() {
                if ((this.parpage.pname == 'home') && (this.parpage.id > 0)) {
                    this.showinfolist(this.parpage.id);
                }

            }
        }

    }
</script>

<style scoped>
</style>
